export default "__VITE_ASSET__BihSdMyK__"